import statistics from "@/mods/workbench/dialog/statistics";
import personal from "@/mods/workbench/dialog/personal";

export default {
  statistics,
  personal,
};
